import apiCall from "../config/apiCall";
import apiKey from "../config/apiKey";

export default async function fetchLandingProducts(airportCode = "", companySlug = "") {
  
  let url = `/productByAirport?key=${apiKey}&airport=${airportCode}`;

  if (companySlug) {
    url += `&companySlug=${companySlug}`;
  }

  const response = await apiCall("get", url, {}, {});
  return response;
}
